import React from "react";
import { Box, Container, Typography, IconButton, Stack, Link } from "@mui/material";
import { motion } from "framer-motion";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";

const PRIMARY = "#06BBC7";
const BLACK = "#111827";

const MotionIconButton = motion(IconButton);

const ContactReminder = () => {
  const contactItems = [
    {
      label: "WhatsApp",
      href: "https://wa.me/593984781610",
      icon: <WhatsAppIcon />,
      external: true,
    },
    {
      label: "Llamar",
      href: "tel:+593984781610",
      icon: <LocalPhoneRoundedIcon />,
      external: false,
    },
    {
      label: "Correo",
      href: "mailto:estetica@lilysunflowers.com",
      icon: <EmailRoundedIcon />,
      external: false,
    },
    {
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=100063547994489",
      icon: <FacebookIcon />,
      external: true,
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/lilyssunflower_",
      icon: <InstagramIcon />,
      external: true,
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        bgcolor: "#ffffff",
        px: { xs: 2, sm: 3, md: 5 },
        py: { xs: 6, sm: 7, md: 8 },
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Container maxWidth="md" disableGutters>
        <Box
          sx={{
            width: "100%",
            maxWidth: 820,
            mx: "auto",
            textAlign: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              m: 0,
              mb: 1.2,
              color: PRIMARY,
              fontSize: { xs: "0.86rem", sm: "0.95rem" },
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            También puedes contactarnos
          </Typography>

          <Typography
            component="h2"
            sx={{
              m: 0,
              mb: 2,
              color: BLACK,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              lineHeight: 1.08,
              fontWeight: 800,
              letterSpacing: "-0.04em",
            }}
          >
            Estamos para ayudarte
          </Typography>

          <Typography
            sx={{
              m: 0,
              mx: "auto",
              mb: { xs: 3.5, sm: 4 },
              maxWidth: 680,
              color: "#4b5563",
              fontSize: { xs: "0.96rem", sm: "1.04rem" },
              lineHeight: 1.75,
              fontWeight: 400,
            }}
          >
            Recuerda que también puedes comunicarte con nosotros por estos medios.
            Síguenos en nuestras redes sociales para conocer nuestro trabajo,
            ver resultados, novedades y consejos para el cuidado de tu piel y tu
            bienestar.
          </Typography>

          <Stack
            direction="row"
            spacing={{ xs: 1.4, sm: 1.8 }}
            useFlexGap
            flexWrap="wrap"
            justifyContent="center"
            sx={{
              width: "100%",
            }}
          >
            {contactItems.map((item, index) => (
              <Box
                key={item.label}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.9,
                  width: { xs: 82, sm: 96 },
                }}
              >
                <MotionIconButton
                  component="a"
                  href={item.href}
                  target={item.external ? "_blank" : undefined}
                  rel={item.external ? "noopener noreferrer" : undefined}
                  aria-label={item.label}
                  initial={{ opacity: 0, y: 16, scale: 0.92 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  whileHover={{ y: -5, scale: 1.08 }}
                  whileTap={{ scale: 0.94 }}
                  transition={{
                    duration: 0.25,
                    ease: "easeOut",
                    delay: index * 0.04,
                  }}
                  viewport={{ once: true, amount: 0.35 }}
                  sx={{
                    width: { xs: 52, sm: 58 },
                    height: { xs: 52, sm: 58 },
                    borderRadius: "50%",
                    border: `2px solid ${PRIMARY}`,
                    color: PRIMARY,
                    bgcolor: "#ffffff",
                    "& svg": {
                      fontSize: { xs: 25, sm: 28 },
                    },
                    "&:hover": {
                      bgcolor: PRIMARY,
                      color: "#ffffff",
                    },
                  }}
                >
                  {item.icon}
                </MotionIconButton>

                <Typography
                  sx={{
                    color: BLACK,
                    fontSize: { xs: "0.82rem", sm: "0.88rem" },
                    lineHeight: 1.3,
                    fontWeight: 700,
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactReminder;